<template>
    <div class="serviceCheck">
        <servicesList></servicesList>
        <div class="tourServer_content" v-if="isEmptyData">
            <div v-html="htmlDecode(saleContent.replace(/\/public/g, weburl +'/public'))"></div>
        </div>
        <div style='width: 100%;text-align: center;margin: 75px 0 ;' v-else>
            <img src='../../assets/images/no_page.png' alt='没有数据' width="160">
        </div>
    </div>
</template>

<script>
    import servicesList from '../../components/services/servicesList';
    export default {
        name: "serviceCheck",
        components: {
            servicesList
        },
        data: function () {
            return {
                isEmptyData: true,
                saleContent: ''
            }
        },
        created: function () {
            this.getSaleInfo();
            // this.$store.commit("set_current_index", 9);
            this.$store.commit("set_current_index", 9);
            this.$store.commit("set_current", 5);
            this.$store.commit("set_title", 'nav.service');
        },
        methods: {
            getSaleInfo: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/serve/getAnti",
                    dataType: "json",
                    data:{
                        anti_id:'1',
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            if (!res.data.result.content) {
                                this.isEmptyData = false;
                            } else {
                                this.isEmptyData = true;
                                this.saleContent = res.data.result.content;
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },

        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }
        }
    }
</script>

<style scoped>

</style>
